<template>
  <div class="nav-bar">
    <!-- inner-nav-bar -->
    <div class="inner-nav-bar">
      <!-- logo -->
      <div class="logo" @click="goHome">
        <img :src="logo" class="img" />
      </div>
      <!-- nav-list -->
      <ul class="nav">
        <!-- <li
          v-for="(item, index) in navList"
          :key="index"
          class="nav-item"
          @click="goPage(item.link, index)"
          :style="{
            color: index === activeNum ? '#fff' : '',
            fontWeight: index === activeNum ? 'bold' : ''
          }"
        >
          {{item.name}}
        </li> -->
      </ul>
      <!-- language -->
      <div class="language">
        <div class="language-logo"></div>
        <div
          class="language-zh"
          :style="{opacity: language === 0 ? 1 : .5}"
          @click="languageChange(0)"
        >
          中
        </div>
        <div class="language-line"></div>
        <div
          class="language-en"
          :style="{opacity: language === 1 ? 1 : .5}"
          @click="languageChange(1)"
        >
          En
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import logo from './logo.svg'

export default {
  components: {},
  props: {
    // newVal: {
    //   type: String
    // }
  },
  watch: {
    // 监听language
    language: function (val) {
      val === 0 ? this.$i18n.locale = 'zh' : this.$i18n.locale = 'en'
      this.navList = [
        { name: this.$t('message.home'), link: '' },
        { name: this.$t('message.news'), link: 'media' },
        { name: this.$t('message.cooperation'), link: 'cooperation' },
        { name: this.$t('message.developer'), link: 'developer' },
        { name: this.$t('message.join_us'), link: 'join' },
        { name: this.$t('message.about_us'), link: 'about' }
      ]
    },
    '$route.path': function (newVal, oldVal) {
      switch (newVal) {
        case '/' : this.activeNum = 0; break
        case '/media' : this.activeNum = 1; break
        case '/cooperation' : this.activeNum = 2; break
        case '/developer' : this.activeNum = 3; break
        case '/join' : this.activeNum = 4; break
        case '/about' : this.activeNum = 5; break
      }
    }
  },
  mounted () {
    // 0 中文  1 英文
    if (localStorage.getItem('lang')) {
      this.language = Number(localStorage.getItem('lang'))
      this.$i18n.locale = Number(localStorage.getItem('lang')) ? 'en' : 'zh'
    } else {
      // 默认中文
      this.language = 0
      this.$i18n.locale = 'zh'
    }
  },
  data () {
    return {
      logo,
      num: 0,
      activeNum: 0,
      language: 0,
      navList: [
        { name: this.$t('message.home'), link: '' },
        { name: this.$t('message.news'), link: 'media' },
        { name: this.$t('message.cooperation'), link: 'cooperation' },
        { name: this.$t('message.developer'), link: 'developer' },
        { name: this.$t('message.join_us'), link: 'join' },
        { name: this.$t('message.about_us'), link: 'about' }
      ]
    }
  },
  computed: {},
  methods: {
    // 页面跳转
    goPage (link, index) {
      if (link === 'developer') {
        window.open('https://open-platform.turingsenseai.com/#/pages/introduction/ai-indentify')
        return
      }
      this.activeNum = index
      if (this.$route.fullPath === `/${link}`) {
        return
      }
      this.$router.push(`/${link}`)
    },
    // 回到首页
    goHome () {
      if (this.$route.fullPath === '/') {
        return
      }
      this.activeNum = 0
      this.$router.push('/')
    },
    // 中英文切换
    languageChange (e) {
      this.language = e
      localStorage.setItem('lang', e)
    }
  },
  created () {
    switch (this.$route.fullPath) {
      case '/' : this.activeNum = 0; break
      case '/media' : this.activeNum = 1; break
      case '/cooperation' : this.activeNum = 2; break
      case '/developer' : this.activeNum = 3; break
      case '/join' : this.activeNum = 4; break
      case '/about' : this.activeNum = 5; break
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar{
  width:100%;
  height: 70px;
  background:#202731;
  background: linear-gradient(to right, #2C3775, #61B4A9);
  display: flex;
  align-items: center;
  position: relative;
  .inner-nav-bar{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;;
    position: relative;
    padding: 0 60px;
    .nav{
      flex: 1;
      margin-left: 100px;
    }
    .logo{

    }
    .language{

    }
  }
}
// logo
.logo{
  width: 150px;
  height: 42px;
  // background: url('../../assets/index/logo.svg') no-repeat center;
  // background-size: contain;
  cursor: pointer;
  .img{
    width: 100%;
    height: 100%;
  }
}
// nav
.nav{
  display: flex;
  margin-left: 67px;
  .nav-item{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    margin-right: 58px;
    color:rgba(255,255,255,0.50);
    &:hover{
      color: #fff;
      cursor: pointer;
    }
  }
}
// language
.language{
  font-size:16px;
  display: flex;
  align-items: center;
  color:rgba(255,255,255,1);
  .language-logo{
    width: 22.81px;
    height: 22.81px;
    background: url('https://oss.turingsenseai.com/1598346728629706135.png') no-repeat center;
    background-size: contain;
    margin-right: 7px;
  }
  .language-zh{
    margin-right: 8px;
    cursor: pointer;
  }
  .language-line{
    width:2px;
    height:18px;
    background: #fff;
    margin-right: 8px;
  }
  .language-en{
    cursor: pointer;
  }
}
</style>
